// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ydHL","content":"styles_content__19S6v","row":"styles_row__2lKvZ","footer":"styles_footer__3PCvE","phraseLength":"styles_phraseLength__1lm8e"};